/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Error from '../../pages/Error/Error';

class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, boundaryError: null };
    this.resetError = this.resetError.bind(this);
  }

  static getDerivedStateFromError(error: any) {
    // Mettez à jour l'état, de façon à montrer l'UI de repli au prochain rendu.
    return { hasError: true, boundaryError: error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Vous pouvez aussi enregistrer l'erreur au sein d'un service de rapport.
    console.error(error, errorInfo);
  }

  resetError() {
    this.setState({ hasError: false, boundaryError: null });
  }

  render() {
    if (this.state.hasError) {
      // Vous pouvez afficher n'importe quelle UI de repli.
      return <Error resetErrorBoundary={this.resetError} errorFromBoundary={this.state.boundaryError} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
